import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal-infinite-spinner',
  templateUrl: './modal-infinite-spinner.component.html',
  styleUrls: ['./modal-infinite-spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalInfiniteSpinnerComponent implements OnInit {
  public mensaje = "";

  constructor() { }

  ngOnInit(): void {
  }

}
